import { gql } from '@apollo/client';

const AnonymousProfileQuery = gql`
  query AnonymousProfile {
    anonymous: currentUser {
      id
      username
      warRoomAvatarUrl
    }
  }
`;

export default AnonymousProfileQuery;
